/**
 * Cell-renderer components shared by the Invoices and Payments EntityTables.
 *
 * Extracted from the *EntityConfig.tsx files so those export only config
 * objects (react-refresh/only-export-components — Fast Refresh needs a file
 * to export either only components or only non-components, not a mix).
 * Same split as `people/config/studentsEntityComponents.tsx`.
 */

import React from 'react';

/** Placeholder for an absent or unresolvable value. */
export const MutedCell: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <span style={{ color: '#94a3b8' }}>{children}</span>
);

/** Right-aligned monetary/numeric cell — digits line up across rows. */
export const NumericCell: React.FC<{
  children: React.ReactNode;
  color?: string;
  bold?: boolean;
}> = ({ children, color, bold }) => (
  <span
    style={{
      fontVariantNumeric: 'tabular-nums',
      color,
      fontWeight: bold ? 600 : undefined,
    }}
  >
    {children}
  </span>
);

/** en-IN short date, or a muted dash when absent. */
export const DateCell: React.FC<{ value: string | null | undefined }> = ({ value }) => {
  if (!value) return <MutedCell>—</MutedCell>;
  return (
    <>
      {new Date(value).toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
      })}
    </>
  );
};
